import React from "react";
import { Box, Typography, IconButton, Divider, Link } from "@mui/material";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";

const EmploymentHistoryCard = ({
  position = "[Position]",
  company = "[Company Name]",
  location = "Irvine, CA",
  years = "[Year Range]",
  description = "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.",
  projects = [],
  onEdit,
  onDelete,
    node,
}) => {
  console.log('====================================');
  console.log(node);
  console.log('====================================');
  return (
    <Box
      sx={{
        display: "flex",
        width: "100%",
        padding: "8px 16px 16px 16px",
        flexDirection: "column",
        alignItems: "flex-start",
        gap: "16px",
        borderRadius: "6px",
        border: "1px solid var(--SMA-sys-light-outline-variant, #D6C1CB)",
        backgroundColor: "#FFF",
        boxShadow:
          "0 1px 2px 0 rgba(0,0,0,0.30), 0 1px 3px 1px rgba(0,0,0,0.15)",
      }}
    >
      <Box
        sx={{
          display: "flex",
          padding: "8px 0",
          justifyContent: "space-between",
          alignItems: "flex-start",
          alignContent: "flex-start",
          rowGap: "8px",
          alignSelf: "stretch",
          flexWrap: "wrap",
        }}
      >
        <Box>
          <Typography
            sx={{
              color: "#21191E",
              fontSize: "16px",
              fontStyle: "normal",
              fontWeight: 500,
              lineHeight: "24px",
              letterSpacing: "0.15px",
                ...node?.lbl1?.style,
            }}
          >
            {node?.lbl1?.label ||position}
          </Typography>
          <Box
            sx={{
              display: "flex",
              gap: 1,
              alignItems: "center",
              color: "#21191E",
              fontSize: "14px",
              fontStyle: "normal",
              fontWeight: 400,
              lineHeight: "20px",
              letterSpacing: "0.25px",

            }}
          >
            <Typography sx={{ ...node?.lbl2?.style }} variant="body2">{node?.lbl2?.label || company}</Typography>
            <Typography sx={{ ...node?.str1?.style }} variant="body2">{node?.str1?.label || "."}</Typography>
            <Typography sx={{ ...node?.lbl3?.style }} variant="body2">{node?.lbl3?.label || location}</Typography>
            <Typography sx={{ ...node?.str2?.style }} variant="body2">{node?.str2?.label || "•"}</Typography>
            <Typography sx={{ ...node?.lbl4?.style }} variant="body2">{node?.lbl4?.label || years}</Typography>
          </Box>
        </Box>

        <Box sx={{ display: "flex", gap: 1 }}>
          <IconButton size="small" aria-label="delete" onClick={onDelete}>
            <DeleteOutlineIcon sx={{ fontSize: 24 }} />
          </IconButton>
          <IconButton size="small" aria-label="edit" onClick={onEdit}>
            <EditOutlinedIcon sx={{ fontSize: 24 }} />
          </IconButton>
        </Box>
      </Box>

      <Box>
        <Typography
          sx={{
            color: "#21191E",
            fontSize: "16px",
            fontStyle: "normal",
            fontWeight: 500,
            lineHeight: "24px",
            letterSpacing: "0.15px",
            ...node?.str3?.style,
          }}
        >
          {node?.str3?.label || "Description"}
        </Typography>
        <Typography
          sx={{
            color: "#21191E",
            fontFamily: "Roboto",
            fontSize: "14px",
            fontStyle: "normal",
            fontWeight: 400,
            lineHeight: "20px",
            letterSpacing: "0.25px",
            ...node?.lbl5?.style,
          }}
        >
          {node?.lbl5?.label || description}
        </Typography>
      </Box>

      <Box>
        <Typography variant="body2" sx={{ fontWeight: 700, mb: 0.5, ...node?.str4?.style }}>
          {node?.str4?.label || "Linked Projects"}
        </Typography>

        <Typography
          sx={{
            color: "#601350",
            fontSize: "14px",
            fontStyle: "normal",
            fontWeight: 400,
            lineHeight: "20px",
            letterSpacing: "0.25px",
            ...node?.lbl6?.style,
          }}
        >
          {node?.lbl6?.label || "Project Name, Project Name, Project Name, Project Name"}
        </Typography>
      </Box>
    </Box>
  );
};

export default EmploymentHistoryCard;
